<template>
  <layout-user :no-footer="true">
    <div class="ai-designer-page">
      <div v-if="aiDesignerStore.loading" class="loading">
        <q-spinner-dots
          class="full-height col-2"
          width="40px"
          color="primary"
        />
      </div>
      <template v-else>
        <svg class="close" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" @click="back()">
          <path d="M18 18L6 6" stroke="#6F8789" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M18 6L6 18" stroke="#6F8789" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="load-cont">
          <div class="load">
            <div class="active" :style="`width:${stepWidth}%`"></div>
          </div>
          <div class="step" :style="`left:calc(${stepWidth}% - 13px)`">{{ selectedStep > aiDesignerStore.stepsCount ? aiDesignerStore.stepsCount : selectedStep}}</div>
        </div>
        <div v-for="(step, index) in aiDesignerStore.data?.steps" :key="step.id">
          <div class="text-block" v-if="selectedStep - 1 === index">
            <div class="text-block__main-title">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                <path stroke="#09373D" stroke-width="1.5" d="M5.0052 4.75272c1.07395-1.07394 2.81515-1.07394 3.88909 0L19.5009 15.3593c1.0739 1.074 1.0739 2.8152 0 3.8891-1.0739 1.074-2.8152 1.074-3.8891 0L5.0052 8.64181c-1.07394-1.07394-1.07394-2.81515 0-3.88909Z"/>
                <path stroke="#09373D" d="m14.7827 2.94037.7913-1.5826c.0737-.14741.2841-.14741.3578 0l.7913 1.5826c.0194.03871.0508.07009.0895.08944l1.5826.7913c.1474.07371.1474.28407 0 .35778l-1.5826.7913c-.0387.01935-.0701.05073-.0895.08944l-.7913 1.5826c-.0737.14741-.2841.14741-.3578 0l-.7913-1.5826c-.0193-.03871-.0507-.07009-.0894-.08944l-1.5826-.7913c-.1474-.07371-.1474-.28407 0-.35778l1.5826-.7913c.0387-.01935.0701-.05073.0894-.08944Zm4.3334 5.33333.4579-.91593c.0737-.14741.2841-.14741.3578 0l.458.91593c.0193.03871.0507.07009.0894.08945l.916.45796c.1474.07371.1474.28407 0 .35778l-.916.45796c-.0387.01936-.0701.05074-.0894.08945l-.458.9159c-.0737.1474-.2841.1474-.3578 0l-.4579-.9159c-.0194-.03871-.0508-.07009-.0895-.08945l-.9159-.45796c-.1474-.07371-.1474-.28407 0-.35778l.9159-.45796c.0387-.01936.0701-.05074.0895-.08945Zm-14.00002 7 .45796-.9159c.07371-.1474.28407-.1474.35778 0l.45796.9159c.01935.0387.05074.0701.08944.0894l.91594.458c.14741.0737.14741.2841 0 .3578l-.91594.458c-.0387.0193-.07009.0507-.08944.0894l-.45796.9159c-.07371.1474-.28407.1474-.35778 0l-.45796-.9159c-.01936-.0387-.05074-.0701-.08945-.0894l-.91593-.458c-.14741-.0737-.14741-.2841 0-.3578l.91593-.458c.03871-.0193.07009-.0507.08945-.0894Z"/>
              </svg>
              AI designer
            </div>
            <p class="text-block__title">
              {{ step.title }}
            </p>
            <p class="text-block__desc">
              {{ step.description }}
            </p>
          </div>
          <div v-if="selectedStep - 1 === index" class="step-cont">
            <div v-if="isHasImg(index)" class="options">
              <div
                v-for="item in aiDesignerStore.filterByDeps(step?.attribute, selectedStep)"
                :key="item.id"
                :class="`options__item ${aiDesignerStore.checked[index].includes(item.id) ? 'active' : ''}`"
                @click="aiDesignerStore.checkedToggle(item.id, index)"
              >
                <div class="options__item__title">
                  <div class="check">
                    <label :class="`checkbox ${aiDesignerStore.checked[index].includes(item.id) ? 'selected' : ''}`">
                      <svg
                        v-if="aiDesignerStore.checked[index].includes(item.id)" width="8" height="6" viewBox="0 0 8 6"
                        fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 3L3 5L7 1" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </label>
                    <p>{{ item.name }}</p>
                  </div>
                </div>
                <div class="options__item__svg" v-html="item.svg_preview?.svg_preview"></div>
              </div>
            </div>
            <div v-else class="options-list">
              <div v-for="item in aiDesignerStore.filterByDeps(step?.attribute, selectedStep)" :key="item.id">
                <div :class="`check ${aiDesignerStore.checked[index].includes(item.id) ? 'selected' : ''}`"
                  @click="aiDesignerStore.checkedToggle(item.id, index)">
                  <label :class="`checkbox ${aiDesignerStore.checked[index].includes(item.id) ? 'selected' : ''}`">
                    <svg
                      v-if="aiDesignerStore.checked[index].includes(item.id)" width="8" height="6" viewBox="0 0 8 6"
                      fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 3L3 5L7 1" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </label>
                  <p>{{ item.name }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-block" v-if="aiDesignerStore.designs.length">
          <div class="text-block__main-title">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
              <path stroke="#09373D" stroke-width="1.5" d="M5.0052 4.75272c1.07395-1.07394 2.81515-1.07394 3.88909 0L19.5009 15.3593c1.0739 1.074 1.0739 2.8152 0 3.8891-1.0739 1.074-2.8152 1.074-3.8891 0L5.0052 8.64181c-1.07394-1.07394-1.07394-2.81515 0-3.88909Z"/>
              <path stroke="#09373D" d="m14.7827 2.94037.7913-1.5826c.0737-.14741.2841-.14741.3578 0l.7913 1.5826c.0194.03871.0508.07009.0895.08944l1.5826.7913c.1474.07371.1474.28407 0 .35778l-1.5826.7913c-.0387.01935-.0701.05073-.0895.08944l-.7913 1.5826c-.0737.14741-.2841.14741-.3578 0l-.7913-1.5826c-.0193-.03871-.0507-.07009-.0894-.08944l-1.5826-.7913c-.1474-.07371-.1474-.28407 0-.35778l1.5826-.7913c.0387-.01935.0701-.05073.0894-.08944Zm4.3334 5.33333.4579-.91593c.0737-.14741.2841-.14741.3578 0l.458.91593c.0193.03871.0507.07009.0894.08945l.916.45796c.1474.07371.1474.28407 0 .35778l-.916.45796c-.0387.01936-.0701.05074-.0894.08945l-.458.9159c-.0737.1474-.2841.1474-.3578 0l-.4579-.9159c-.0194-.03871-.0508-.07009-.0895-.08945l-.9159-.45796c-.1474-.07371-.1474-.28407 0-.35778l.9159-.45796c.0387-.01936.0701-.05074.0895-.08945Zm-14.00002 7 .45796-.9159c.07371-.1474.28407-.1474.35778 0l.45796.9159c.01935.0387.05074.0701.08944.0894l.91594.458c.14741.0737.14741.2841 0 .3578l-.91594.458c-.0387.0193-.07009.0507-.08944.0894l-.45796.9159c-.07371.1474-.28407.1474-.35778 0l-.45796-.9159c-.01936-.0387-.05074-.0701-.08945-.0894l-.91593-.458c-.14741-.0737-.14741-.2841 0-.3578l.91593-.458c.03871-.0193.07009-.0507.08945-.0894Z"/>
            </svg>
            AI designer
          </div>
          <p class="text-block__title">Your designs are ready!</p>
          <p class="text-block__desc">
            You can save any of the designs, modify it, or generate others by clicking the "Load more" button.
          </p>
        </div>
        <div v-if="aiDesignerStore.designs.length" class="step-cont">
          <div  class="options">
            <div class="options__item"
              v-for="(design, index) in aiDesignerStore.designs" :key="design.id"
              @click="openDesign(design)"
            >
              <div class="options__item__title">
                <p>Design {{ index + 1 }}</p>
              </div>
              <div v-if="design.loading" class="options__loader">
                <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
                  <g clip-path="url(#clip0_719_13172)">
                    <path d="M21 10.5V5.25" stroke="#09373D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M10.5 21H5.25" stroke="#09373D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path
                      d="M13.5623 13.5625L9.7998 9.79999" stroke="#09373D" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_719_13172">
                      <rect width="42" height="42" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div class="options__item__svg" v-else-if="design.designOptions">
                <sketch-image
                  noUpdate
                  :design-options="design.designOptions"
                  :elements="design.elements"
                  :desc-items="[]"
                />
              </div>
            </div>
          </div>
          <div v-if="aiDesignerStore.loadMore" style="text-align:center;">
            <q-spinner-dots
              class="full-height col-2"
              width="40px"
              color="primary"
            />
          </div>
        </div>
        <div class="buttons">
          <ButtonSecondary class="small" @click.native="back()" v-if="aiDesignerStore.stepsCount > selectedStep">
            <template v-slot:icon>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                <path stroke="#09373D" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M14.1668 10H5.8335m3.33333 3.3327L5.8335 9.99935l3.33333-3.33333"/>
              </svg>
            </template>
            Back
          </ButtonSecondary>
          <ButtonPrimary
            class="small"
            :disabled="isDisable"
            @click.native="next()">
            {{nexButtonText}}
          </ButtonPrimary>
        </div>
      </template>
    </div>
  </layout-user>
</template>

<script>
import { mapStores } from 'pinia'
import { useAiDesignerStore } from '@/store/pinia/aiDesugner'

import LayoutUser from '@/layouts/LayoutUser'
import ButtonPrimary from '@/components/Atoms/ButtonPrimary.vue'
import ButtonSecondary from '@/components/Atoms/ButtonSecondary.vue'
import SketchImage from '@/components/Sketch/SketchImage.vue'

export default {
  name: 'AiDesigner',
  components: {
    LayoutUser,
    ButtonPrimary,
    ButtonSecondary,
    SketchImage,
  },
  data: () => ({
    selectedStep: 1,
  }),
  computed: {
    ...mapStores(useAiDesignerStore),
    nexButtonText () {
      return this.aiDesignerStore.stepsCount - 1 < this.selectedStep ? 'Load more' : 'Next'
    },
    stepWidth () {
      const width = (this.selectedStep / this.aiDesignerStore.stepsCount) * 100
      return width > 100 ? 100 : width
    },
    isDisable () {
      return !this.aiDesignerStore.checked[this.selectedStep - 1]?.length && this.aiDesignerStore.stepsCount > this.selectedStep
    },
  },
  methods: {
    openDesign (data) {
      this.$router.push(
        {
          name: 'PageDesigner',
          params: {
            designCategory: this.$route.params.category,
            mannequinId: this.$route.query.mannequinId,
            mannequinType: this.$route.query.mannequinType,
            mannequinName: this.$route.query.mannequinName,
            fitChartsIsCustom: this.$route.query.fitChartsIsCustom,
            mannequinIdNew: this.$route.query.mannequinIdNew,
            fitChartsId: this.$route.query.fitChartsId,
            elementIds: data.designOptions.elementIds,
            isAiDesign: true,
          },
        },
      )
    },
    next () {
      this.selectedStep++
      if (this.aiDesignerStore.stepsCount - 1 < this.selectedStep) {
        this.aiDesignerStore.getDesigns(this.$route.params.category)
      }
    },
    back () {
      if (this.selectedStep === 1) {
        this.$router.push('/new-design')
      } else this.selectedStep--
    },
    isHasImg (index) {
      const step = this.aiDesignerStore.data?.steps?.[index]
      const filteredAttrs = this.aiDesignerStore.filterByDeps(step?.attribute, index + 1)
      return filteredAttrs.find(el => el.svg_preview)
    },
  },
  async beforeMount () {
    this.aiDesignerStore.allReset()
    await this.aiDesignerStore.getList(this.$route.params.category)
  },
}
</script>

<style lang="scss">
.ai-designer-page {
  height: 100%;
  max-width: 1166px;
  margin: auto;
  padding: 32px 16px;
  color: var(--Text-Text_Primary);
  font-family: "DM Sans";
  font-size: 16px;
  line-height: 150%;
  .loading {
    height: 100%;
    text-align: center;
  }
  p {
    margin: 0;
  }
  .close {
    position: absolute;
    left: 16px;
    top: 24px;
    cursor: pointer;
  }
  .step-cont {
    margin-bottom: 122px;
  }
  .options-list {
    max-width: 442px;
    margin: auto;
    .check.selected {
      border-color: var(--Active-State-Strokes, #FF6770);
    }
    .check {
      cursor: pointer;
      padding: 12px;
      border-radius: 8px;
      border: 1px solid var(--Dividers);
      .checkbox {
        margin-right: 16px;
      }
      p {
        font-size: 16px !important;
      }
    }
  }
  .options {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    row-gap: 98px;
    column-gap: 35px;
    margin-bottom: 32px;
    .check {
      margin-bottom: 0;
    }
    &__loader {
      display: flex;
      align-items: center;
      justify-content: center;
      height: calc(100% - 40px);
      svg {
        animation: spin 1.5s linear infinite;
      }
    }
    &__item {
      height: 237px;
      border-radius: 12px;
      border: 1px solid var(--contour, rgba(15, 104, 116, 0.14));
      padding: 8px;
      cursor: pointer;
      &__title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid var(--contour, rgba(15, 104, 116, 0.14));
        padding: 4px 0 8px;
        position: relative;
        min-height: 38px;
        .size-name {
          font-size: 14px;
          margin-bottom: 0;
          padding-left: 8px;
        }
      }
      &__svg {
        margin-top: 8px;
        padding: 0 8px;
        height: calc(100% - 45px);
        display: flex;
        align-items: center;
        justify-content: center;
        svg {
          overflow: visible;
          width: 100%;
          height: 100%;
        }
      }
    }
    &__item.active {
      border: 1px solid#FF6770;
      .auto_grading__item__title {
        color: #FF6770;
        font-weight: 600;
      }
    }
  }
  .buttons {
    left: 0;
    border-top: 1px solid var(--Dividers);
    padding: 16px;
    display: flex;
    gap: 16px;
    width: 100%;
    bottom: 0;
    position: fixed;
    justify-content: center;
    background: var(--Background);
    button {
      width: 212px;
    }
  }
  .text-block {
    margin: 55px auto 47px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    max-width: 442px;
    text-align: center;
    &__main-title {
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: 600;
      line-height: 20px;
    }
    &__title {
      font-family: Unbounded;
      font-size: 20px;
      font-weight: 600;
      line-height: 130%;
    }
    &__desc {
      color: var(--Text-Text_Secondary);
    }
  }
  .load-cont {
    display: flex;
    align-items: center;
    position: relative;
    .load {
      width: 100%;
      height: 8px;
      border-radius: 20px;
      background: var(--input_hover);
      .active {
        border-radius: 20px;
        background: var(--accent);
        height: 8px;
      }
    }
    .step {
      border-radius: 1000px;
      border: 2px solid var(--Background);
      background: var(--accent);
      display: flex;
      width: 24px;
      height: 24px;
      padding: 3px 0;
      justify-content: center;
      align-items: center;
      color: var(--Background);
      font-family: "DM Sans";
      font-size: 14px;
      font-weight: 600;
      position: absolute;
    }
  }
}
@media (max-width: 1240px) {
  .ai-designer-page .close {
    position: initial;
    margin-bottom: 12px;
  }
}
@media (max-width: 1100px) {
  .ai-designer-page .options {
    grid-template-columns: repeat(4, 1fr);
    row-gap: 40px;
    column-gap: 15px;
  }
}
@media (max-width: 964px) {
  .ai-designer-page .options {
    grid-template-columns: repeat(3, 1fr);
    row-gap: 40px;
    column-gap: 15px;
  }
}
@media (max-width: 480px) {
  .ai-designer-page .options {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 16px;
    column-gap: 16px;
    &__item__title .size-name {
      font-size: 14px;
    }
  }
}
</style>
